import { Component, input } from '@angular/core';
import { FileResponse } from '../../../../core/clients/omni-core/models';
import { DatePipe } from '@angular/common';
import { DocumentFilenamePipe } from '../../pipes/document-filename-pipe';
import { TranslocoPipe } from '@jsverse/transloco';
import { SimpleDialog, Button } from 'excellence-ui';
import { DocumentShareDialog } from '../../dialogs/document-share-dialog/document-share-dialog';
import { NgIcon } from '@ng-icons/core';
import { DisableInDemoModeDirective } from '../../../demo/directives/disable-in-demo-mode';

@Component({
  selector: 'app-document-preview-header',
  imports: [
    DatePipe,
    DocumentFilenamePipe,
    TranslocoPipe,
    SimpleDialog,
    DocumentShareDialog,
    Button,
    NgIcon,
    DisableInDemoModeDirective,
  ],
  templateUrl: './document-preview-header.html',
})
export class DocumentPreviewHeader {
  document = input.required<FileResponse>();
  organizationId = input.required<string>();
}
